import { createStore, compose, applyMiddleware } from "redux";
import createSagaMiddleware from 'redux-saga'

// saga文件
import Sagas from './sagas'
import HeaderSaga from "./sagas/HeaderSaga"
import UserSaga from "./sagas/UserSaga"
import ActivitySaga from "./sagas/ActivitySaga"



// import thunk from 'redux-thunk'
import reducer from './reducer'

const sagaMiddleware = createSagaMiddleware() //创建saga中间件
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(
    applyMiddleware(sagaMiddleware) //添加saga中间件到enhancer里
)
const store = createStore(
    reducer,
    enhancer
);

// 开启中saga中间件
sagaMiddleware.run(Sagas)
sagaMiddleware.run(HeaderSaga)
sagaMiddleware.run(UserSaga)
sagaMiddleware.run(ActivitySaga)



export default store;
